import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux';
import { apiUrl, pageUrl, protocol } from '../../utils/url';
import { hideLoader, showLoader } from '../loader';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import Skeleton from 'react-loading-skeleton';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

const CampaignPreview = ({ moveNext, moveBack }) => {
    const { slug } = useSelector(state => state?.slugReducer);
    const history = useHistory();
    const [pagePreview, setPagePreview] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const sliderRef = useRef(null);

    // const pagePreview = [
    //     {
    //         name:"Elon Musk",
    //         image: "https://images.genpage.ai/public/465b81d0d64a7439219242d8413890ed926eb2e6c8d2f6ee4ab7.png",
    //         url:`${protocol}${slug ? slug : localStorage?.slug}.${pageUrl}/tesla`
    //     },
    //     {
    //         name:"Tim Cook",
    //         image: "https://images.genpage.ai/public/d84beb8ba2a7b1268be3439340c79962bc2b0ac2787eee28f9a8.png",
    //         url:`${protocol}${slug ? slug : localStorage?.slug}.${pageUrl}/apple`
    //     },
    //     {
    //         name:"Jeff Bezos",
    //         image: "https://images.genpage.ai/public/d8a7e20c4c6d00eaaed243334d71b411b00131fceab30c1ef5ac.png",
    //         url:`${protocol}${slug ? slug : localStorage?.slug}.${pageUrl}/amazon`
    //     }
    // ];
    const getCampaigns = async (e) => {
        showLoader()
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`);
        fetch(apiUrl + "/get-default-campaigns",{
            headers:myHeaders,
        })
        .then(async (res) => {
            hideLoader()
            const response = await res.json();
            setPagePreview(response?.data)
            setIsLoading(false)
        }).catch((err) => {
            setIsLoading(false)
            // console.log(err)
            hideLoader()
        })
    }
    useEffect(() => {
        if (pagePreview.length == 0) {
            setIsLoading(true)
            getCampaigns() 
        }else {
            setIsLoading(false)
        } 

    }, [])
    const nextStep = (e, from) => {
        showLoader();
        var myHeaders = new Headers();

        myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`)
        const formdata = new FormData();
        formdata.append('step',e?.target?.dataset?.step)
        formdata.append('project',slug ?slug: localStorage?.slug)
        if (from == 'back') {
            formdata.append('back',1)
        }
        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: formdata,
            redirect: 'follow'
        };

        fetch(apiUrl + "/walkthrough", requestOptions)
            .then(async (res) => {
                const response = await res?.json();
                if (response?.status_code == 200) {
                    if (from == "next" || from == "skip") {
                        toast.success(response?.status_message)

                        hideLoader()
                        localStorage.removeItem("lastStep")
                        localStorage.removeItem("currentStep")
                        localStorage.removeItem("walkthrough_step")
                        localStorage.setItem("walkthrough", 1)
    
                        history.push({
                            pathname: "/project/" + (slug ? slug  : localStorage?.slug) + "/campaigns",
                            state: {
                                sidebarOpen: true,
                                welcomeModalOpen: true
                            }
                        });
                        history.go()
                    }
                    else if (from == "back") {
                        moveBack(e, response)

                        hideLoader()
                    }
                }
                else {
                    toast.error(response?.status_message)

                    hideLoader()
                }

            }).catch((err) => {
                hideLoader()
            })
    }

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        centerMode: true,
        slidesToShow: 1,
        variableWidth: true,
        slidesToScroll: 1
        // responsive: [
        //     {
        //         breakpoint: 768,
        //         settings: {
        //             arrows: true
        //         }
        //     }
        // ]
    };
    const PrevArrow = (props) => {
        const { onClick } = props;
        return (
              <button className="carousel-btn carousel-btn-prev" onClick={onClick}>
                &#10094;
            </button>
        );
    };

    // Custom Next Arrow Component
    const NextArrow = (props) => {
        const { onClick } = props;
        return (
            <button className="carousel-btn carousel-btn-next" onClick={onClick}>
                &#10095;
            </button>
        );
    };
    return (
        <div style={{ paddingBottom: "50px"}}>
            <div className="step-heading" style={{padding: "25px 50px 0 50px"}}>Preview your campaign</div> 
            <small className='d-block' style={{padding: "0px 50px 10px 50px"}}>  Here’s a preview of your campaign based on your onboarding details. <br />
            You’ll be able to edit it in the next step.</small>
            <div style={{padding:"0 50px"}} className="campaign-preview-container-walkthrough mt-20px">
                <Slider ref={sliderRef} {...settings}>
                {
                    (pagePreview && pagePreview.length > 0 ? pagePreview : Array(3).fill({ name: "Placeholder", logo: "placeholder-logo.png", url: "#" }))?.map((val,index)=>(
                        <div className='campaign-preview-main' key={`${index}-${val?.url}`}>
                            <div className="preview-header">
                                <div className='preview-header-left'>
                                    <div className='preview-logo'>
                                        {
                                            isLoading ?
                                            <Skeleton width={"100%"} height={"100%"}/>
                                            :
                                            <img src={val?.logo} alt="" />
                                        }
                                    </div>
                                    <span>
                                        {
                                            
                                            isLoading ?
                                            <Skeleton width={"100%"} height={"100%"}/>
                                            : val?.name
                                        }
                                    </span>
                                </div>
                                {
                                isLoading ?
                                <Skeleton width={"100%"} height={"100%"}/>
                                :
                                <a href={val?.url} target='_blank' className='cursor-pointer border-radius-9 fs-12 btn-fafafa' style={{ height: "25px" }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="11" viewBox="0 0 15 15" fill="none">
                                        <rect x="10.3594" y="3.86816" width="1.348" height="10.11" rx="0.673998" transform="rotate(45 10.3594 3.86816)" fill="#1188FF" />
                                        <rect x="11.4492" y="3.52637" width="1.38781" height="6.93906" rx="0.693906" transform="rotate(90 11.4492 3.52637)" fill="#1188FF" />
                                        <rect width="1.38781" height="6.93906" rx="0.693906" transform="matrix(-1 0 0 1 11.5312 3.60938)" fill="#1188FF" />
                                    </svg>
                                    <span className="text-decoration-none text-dark">
                                    View landing page
                                    </span>
                                </a>
                                }
                            </div>
                            <div className='walkthorugh-campaign-preview'>
                                <iframe src={val?.url}></iframe>
                            </div>
                        </div>
                    ))
                }
                </Slider>
                <div>
                    <PrevArrow onClick={() => sliderRef.current.slickPrev()} />
                    <NextArrow onClick={() => sliderRef.current.slickNext()} />
                </div>
            </div>
            <div className='form-group mt-20px d-flex justify-content-end gap-1 me-4'>
                <button  type="button" className="register-btn border-0" data-step="4" data-backstep="3"
                onClick={(e) => nextStep(e, "back")}>
                    Back
                </button>
                <button type="button" onClick={(e) => nextStep(e,'next')} data-step="4"  className="fs-12 shadow-none  project-blue-btn ">
                Continue to workspace
                </button>
            </div>
        </div>
    )
}

export default CampaignPreview